/**
 * Enum representing valid redirect paths for redirection if they exist in the URL.
 * Add valid redirect paths as key-value pairs to this enum.
 * Key: Enum name, Value: Corresponding valid redirect path
 * */
export enum RedirectPaths {
  SELLER_PORTAL = "/",
  PARCEL = "/parcel",
}
